// ShellPanel.jsx — Shared left column chrome for Apps, Connect, and Workspace

import React from 'react';

import './ShellPanel.css';

/**
 * ShellPanel
 *
 * Rounded bucket-style aside used by both Sources (Simple) and Workspace shells.
 *
 * @param {object} props
 * @param {ReactNode} props.children
 * @param {string} [props.className]
 * @param {string} [props.bodyClassName]
 * @param {ReactNode} [props.header] - Optional header slot (e.g. ShellHeader).
 * @returns {ReactNode}
 */
const ShellPanel = React.memo(({
  children,
  className = '',
  bodyClassName = '',
  header = null,
}) => (
  <aside
    className={['shell-panel', className].filter(Boolean).join(' ')}
    aria-label="Shell panel"
  >
    {header}
    <div className={['shell-panel__body', bodyClassName].filter(Boolean).join(' ')}>
      {children}
    </div>
  </aside>
));

ShellPanel.displayName = 'ShellPanel';

export default ShellPanel;
